import { useApplicationUpdater } from '../../../queries/useApplicationUpdater';

/**
 * Returns a function that removes a property from `information.properties.items` and
 * updates `currentPropertyId` to the next available property (or null if none remain).
 *
 * Used by PropertyReviewPanel when the user confirms deletion of a property.
 *
 * @returns (propertyGuid: string) => void
 */
export function useDeleteProperty(): (propertyGuid: string) => void {
    const update = useApplicationUpdater();

    return (propertyGuid: string) => {
        update((old) => {
            const items = (old.information?.properties?.items ?? []).filter(
                (p) => p.guid !== propertyGuid
            );
            const currentPropertyId = old.information?.properties?.currentPropertyId;
            const newCurrentPropertyId =
                currentPropertyId === propertyGuid
                    ? (items[0]?.guid ?? null)
                    : (currentPropertyId ?? null);
            return {
                ...old,
                information: {
                    ...old.information,
                    properties: {
                        ...old.information.properties,
                        items,
                        currentPropertyId: newCurrentPropertyId,
                    },
                },
            };
        });
    };
}
